module.exports = __webpack_public_path__ + "static/media/pm_playstore.16afef05.svg";